import { IAreas } from "../../@types/API/IArea";

export function getAreasAsOptions(areas: IAreas) {
  return areas.map((area) => ({ label: `${area.name}`, value: area.id }));
}